export function navigateToAppPath(pathname: string) {
  if (window.location.pathname === pathname) return;

  window.history.pushState({}, "", pathname);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function navigateToBusinessSetup() {
  navigateToAppPath("/app/setup");
}
